import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navigation.css";

interface MobileNavigationProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({ isOpen, onClose }) => {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      // Ensure body doesn't scroll when menu is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const toggleDropdown = (name: string) => {
    if (activeDropdown === name) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(name);
    }
  };

  return (
    <div className={`mobile-menu ${isOpen ? "active" : ""}`} style={{ zIndex: 99999 }}>
      <div className="mobile-menu-backdrop" style={{ zIndex: 99990 }}></div>
      <div className="mobile-menu-content" style={{ position: "relative", zIndex: 99995 }}>
        <button className="mobile-menu-close" onClick={onClose} style={{ zIndex: 100000 }}>
          <span></span>
          <span></span>
        </button>

        <div className="mobile-nav-links">
          <div className={`mobile-nav-item ${activeDropdown === "solutions" ? "active" : ""}`}>
            <button className="mobile-nav-link" onClick={() => toggleDropdown("solutions")}>
              <span className="mobile-nav-link-text">SOLUTIONS</span>
              <span className="mobile-dropdown-arrow">▼</span>
            </button>
            <div className="mobile-dropdown">
              <Link to="/solutions/resonance" className="mobile-dropdown-item" onClick={onClose}>
                Resonance
              </Link>
              <Link to="/solutions/autonomous-soc" className="mobile-dropdown-item" onClick={onClose}>
                Autonomous SOC Agent
              </Link>
              <Link to="/solutions/intelligence-platform" className="mobile-dropdown-item" onClick={onClose}>
                Internet-wide Intelligence
              </Link>
            </div>
          </div>

          <div className={`mobile-nav-item ${activeDropdown === "industries" ? "active" : ""}`}>
            <button className="mobile-nav-link" onClick={() => toggleDropdown("industries")}>
              <span className="mobile-nav-link-text">INDUSTRIES</span>
              <span className="mobile-dropdown-arrow">▼</span>
            </button>
            <div className="mobile-dropdown">
              <Link to="/industries/government" className="mobile-dropdown-item" onClick={onClose}>
                Government
              </Link>
              <Link to="/industries/telecommunications" className="mobile-dropdown-item" onClick={onClose}>
                Telecommunications
              </Link>
              <Link to="/industries/energy" className="mobile-dropdown-item" onClick={onClose}>
                Energy & Utilities
              </Link>
              <Link to="/industries/financial" className="mobile-dropdown-item" onClick={onClose}>
                Financial Services
              </Link>
              <Link to="/industries/healthcare" className="mobile-dropdown-item" onClick={onClose}>
                Healthcare
              </Link>
              <Link to="/industries/retail" className="mobile-dropdown-item" onClick={onClose}>
                Retail
              </Link>
              <Link to="/industries/it" className="mobile-dropdown-item" onClick={onClose}>
                IT & Services
              </Link>
              <Link to="/industries/manufacturing" className="mobile-dropdown-item" onClick={onClose}>
                Manufacturing
              </Link>
            </div>
          </div>

          <Link to="/about" className="mobile-nav-link" onClick={onClose}>
            <span className="mobile-nav-link-text">COMPANY</span>
          </Link>
        </div>

        <div className="mobile-header-actions">
          <div className="mobile-security-incident">
            <a href="/report-incident" className="mobile-incident-link" onClick={onClose}>
              Encountered a security incident?
            </a>
          </div>

          <div className="mobile-action-links">
            <Link to="/book-demo" className="mobile-action-link" onClick={onClose}>
              <span className="demo-icon"></span>Book a demo
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNavigation;
